var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlass6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 48,
    viewBox: "0 0 52 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.59375 37.002L7.53996 32.3072",
    stroke: "#219EBC",
    strokeWidth: 3.2407,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0469 37.002L44.4594 32.3072",
    stroke: "#219EBC",
    strokeWidth: 3.2407,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3281 21.3516H30.6901",
    stroke: "#219EBC",
    strokeWidth: 3.2407,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3178 17.6306V25.3308C21.3178 30.0118 19.4454 31.8842 14.7644 31.8842H9.14717C4.46615 31.8842 2.59375 30.0118 2.59375 25.3308V17.6306C2.59375 12.9496 4.46615 11.0771 9.14717 11.0771H14.7644C19.4454 11.0771 21.3178 12.9496 21.3178 17.6306Z",
    stroke: "#219EBC",
    strokeWidth: 3.2407,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4115 17.6306V25.3308C49.4115 30.0118 47.5391 31.8842 42.8581 31.8842H37.2409C32.5599 31.8842 30.6875 30.0118 30.6875 25.3308V17.6306C30.6875 12.9496 32.5599 11.0771 37.2409 11.0771H42.8581C47.5391 11.0771 49.4115 12.9496 49.4115 17.6306Z",
    stroke: "#219EBC",
    strokeWidth: 3.2407,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlass6);
export default __webpack_public_path__ + "static/media/glass6.dabe1c43986da180b8c08af064f189b0.svg";
export { ForwardRef as ReactComponent };